import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AppService {
    readonly isFooterVisible = signal(true);
    readonly isFullScreen = signal(false);

    hideFooter() {
        this.isFooterVisible.set(false);
    }

    showFooter() {
        this.isFooterVisible.set(true);
    }

    enableFullScreen() {
        this.isFullScreen.set(true);
    }

    disableFullScreen() {
        this.isFullScreen.set(false);
    }
}
